export const validateEmail = (value: string, label: string) => {
  if (!value) {
    return `${label} is required`;
  }
  const emailRegex = /\S+@\S+\.\S+/;
  if (!emailRegex.test(value)) {
    return 'Invalid email address';
  }

  return '';
};

export const validateEmpty = (value: string, label: string) => {
  if (!value) {
    return `${label} is required`;
  }

  return '';
};

export const validateDateFormat = (value: string, label: string) => {
  if (!value) {
    return `${label} is required`;
  }

  return '';
};

export const validatePhoneNumber = (value: string) => {
  const phoneRegExp = /^\+?[0-9\s\-()]{1,20}$/;

  if (!value) {
    return 'Phone number is required';
  }

  if (!phoneRegExp.test(value)) {
    return 'Invalid phone number format';
  }

  return '';
};

export const validateNPI = (npi: string) => {
  if (!/^\d{10}$/.test(npi)) {
    return false;
  }

  const digits = npi.split('').map(Number);
  const checkDigit = digits.pop();
  const baseDigits = [8, 0, 8, 4, 0, ...digits];

  const sum = baseDigits
    .reverse()
    .map((digit, index) => (index % 2 === 0 ? digit * 2 : digit))
    .map(digit => (digit > 9 ? digit - 9 : digit))
    .reduce((acc, val) => acc + val, 0);

  const computedCheckDigit = (10 - (sum % 10)) % 10;

  return computedCheckDigit === checkDigit;
};

export const validateNPIs = (npis: string) => {
  const npiList = npis.split(',').map(npi => npi.trim());

  if (!npiList.every(npi => validateNPI(npi))) {
    return 'Please review the list of NPIs. Each NPI must be exactly 10 digits and valid.';
  }

  return '';
};

export const validate = (required: boolean, type: string, value: string, label: string, fieldName?: string) => {
  if (value === '' && !required) {
    return '';
  }
  if (fieldName === 'Email') {
    return validateEmail(value, fieldName);
  }
  if (fieldName === 'Phone Number') {
    return validatePhoneNumber(value);
  }
  if (fieldName === 'NPI') {
    return validateNPIs(value);
  }
  if (type === 'date' && required) {
    return validateDateFormat(value, label);
  }
  if (required === true) {
    return validateEmpty(value, label);
  }

  return '';
};
